import FairlyLogo from '@/ui/assets/logo-fairly-white.png';

export function Logo() {
  return <img src={FairlyLogo} alt="Fairly Logo" />;
}
